
const filters = document.querySelectorAll('.filter');
const itemFilter = document.querySelectorAll('.cardfilter');
const filterAll = document.querySelector('[data-filter=all]');

// console.log(itemFilter)

// itemFilter.forEach(element => {
//     let selectedFilter = element.getAttribute('data-filter');
//     console.log(selectedFilter)

// });

filters.forEach(filter => { 

  filter.addEventListener('click', function () {
    const filterSelected = 'filter--selected'

    if (!filter.classList.contains(filterSelected)) {
      filter.classList.add(filterSelected)
    } else {
      filter.classList.remove(filterSelected)
    }

    let selectedFilter = filter.getAttribute('data-filter');
    let itemsToHide = document.querySelectorAll(`.cardsfilters .cardfilter:not([data-filter='${selectedFilter}'])`);
    let itemsToShow = document.querySelectorAll(`.cardsfilters [data-filter='${selectedFilter}']`);

    if (selectedFilter == 'all') {
      itemsToHide = [];
      itemsToShow = document.querySelectorAll('.cardsfilters [data-filter]');
    }

    itemsToHide.forEach(el => {
      el.classList.add('hide');
      el.classList.remove('show');
    });
    
    itemsToShow.forEach(el => {
      el.classList.remove('hide');
      el.classList.add('show'); 
    });

  });
});

// filterAll.addEventListener('click', function () {

// });